import { PaymentSection } from 'domains/signupDirect/Evaluation/Deposit/PaymentSection';
import { getEvaluationPrice } from 'domains/signupDirect/misc/evalPrice';
import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { DIRECT_SIGNUP_MIXPANEL_EVENTS } from 'domains/signupDirect/misc/mixpanelTracking';
import { EvaluationFormType } from 'domains/signupDirect/schemas/evaluationSchema';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTrack } from 'utils/hooks/useMixPanel';

const PrivatePaySections: React.FC = () => {
  const { isResumedLead } = useSignupDirectCtx();
  const { track } = useTrack();
  const paymentType = useWatch<EvaluationFormType, 'billingInfo.type'>({ name: 'billingInfo.type' });

  const evaluationPrice = getEvaluationPrice({
    isPrivatePay: true,
  });

  if (paymentType === 'privatePay') {
    track(DIRECT_SIGNUP_MIXPANEL_EVENTS.STEPS.EVAL.FORM_PRIVATE_PAY, { isResumedLead });
    return (
      <>
        <PaymentSection evaluationPrice={evaluationPrice} />
      </>
    );
  }

  return null;
};

export default PrivatePaySections;
